import { environment } from 'src/environments/environment';

/**
 * Vérifie que l'URL fournie appartient à la whitelist des hôtes JFSE autorisés
 * (environment.jfseAllowedHosts) avant tout usage dans un iframe via bypassSecurityTrustResourceUrl.
 *
 * Retourne false si l'URL est invalide ou si le domaine n'est pas autorisé.
 */
export function isAllowedIframeUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    const allowedHosts = new Set<string>(environment.jfseAllowedHosts);
    return allowedHosts.has(parsed.hostname);
  } catch {
    return false;
  }
}

/**
 * Vérifie que l'URL fournie appartient à la whitelist des hôtes externes autorisés
 * (environment.allowedExternalHosts) avant tout usage dans window.open() ou tout
 * autre contexte de navigation externe.
 *
 * Retourne false si l'URL est invalide ou si le domaine n'est pas autorisé.
 */
export function isAllowedExternalUrl(url: string): boolean {
  try {
    const parsed = new URL(url);
    const allowedHosts = new Set<string>(environment.allowedExternalHosts);
    return allowedHosts.has(parsed.hostname);
  } catch {
    return false;
  }
}
